/**
 * @generated SignedSource<<1165c97eebf17e8677440c81d61a7ea1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFDFQuoteVariant_deliveryOptions$data = ReadonlyArray<{
  readonly isFromDealer: boolean | null;
  readonly serviceMethod: {
    readonly isFreight: boolean | null;
    readonly serviceType: string | null;
  } | null;
  readonly " $fragmentType": "useFDFQuoteVariant_deliveryOptions";
}>;
export type useFDFQuoteVariant_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: useFDFQuoteVariant_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFDFQuoteVariant_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useFDFQuoteVariant_deliveryOptions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFreight",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFromDealer",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "e252e734d0e91835c6d1307ff48a9d53";

export default node;
